export const Types = {
    SAVE_LIST_IMAGE: 'SAVE_LIST_SERVICE',
}
